import $ from 'jquery'

$(document).ready(function () {
    $('select#id_country').on('input',function(e){
        // If country is not Slovenia, then disable checkbox for company
        if($(this).val() != 203){
            $('.register_company').addClass('hidden')
            $('.form_pravna_oseba').addClass('hidden')
        }
        if($(this).val() == 203){
            $('.register_company').removeClass('hidden')
            $( ".register_company" ).prop( "checked", false );
            $('#id_company').val('')
            $( "#id_vat_taxable" ).prop( "checked", false );
            $('#id_vat').val('')
        }
    });
});